import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
	const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
	const isMotionReduced = () =>
		motionQuery.matches || document.documentElement.classList.contains('reduce-motion')

	// Store active tweens/triggers per section so we can kill them on demand
	const instances = []

	document.querySelectorAll(".callout-shape").forEach((section) => {
		const shape = section.querySelector(".ratking")
		if (!shape) return

		instances.push({ section, shape, tween: null, trigger: null })
	})

	function startAnimations() {
		instances.forEach((inst) => {
			if (inst.tween) return // already running

			gsap.set(inst.shape, { willChange: "transform" })

			inst.tween = gsap.to(inst.shape, {
				rotation: 90,
				ease: "power1.inOut",
				scrollTrigger: {
					trigger: inst.section,
					start: "top bottom",
					end: "bottom top",
					scrub: 1.25,
					onToggle: (self) => { inst.trigger = self },
				},
			})
		})
	}

	function stopAnimations() {
		instances.forEach((inst) => {
			if (inst.tween) {
				inst.tween.kill()
				inst.tween = null
			}
			if (inst.trigger) {
				inst.trigger.kill()
				inst.trigger = null
			}
			// Reset the shape to its natural position
			gsap.set(inst.shape, { rotation: 0, willChange: "auto" })
		})
		ScrollTrigger.refresh()
	}

	function onMotionChange() {
		if (isMotionReduced()) {
			stopAnimations()
		} else {
			startAnimations()
		}
	}

	// Watch for the accessibility widget toggling html.reduce-motion
	new MutationObserver(onMotionChange).observe(document.documentElement, {
		attributes: true,
		attributeFilter: ['class'],
	})

	// Watch for OS-level preference changes
	motionQuery.addEventListener('change', onMotionChange)

	// Initialize
	if (!isMotionReduced()) {
		startAnimations()
	}
})
